/**
 * Copyright 2024 AutoZone, Inc.
 * Content is confidential to and proprietary information of AutoZone, Inc., its
 * subsidiaries and affiliates.
 */
import type React from 'react';
import { createContext } from 'react';

export type VehicleData = {
  value: string;
  label: string;
};

export type CurrentVehicle = {
  year?: string;
  make?: VehicleData;
  model?: VehicleData;
  submodelID?: string | undefined;
  driveTypeID?: number;
  vehicleType?: string;
};

export type YMMEInfoContexValue = {
  activeStep: number;
  setActiveStep: React.Dispatch<React.SetStateAction<number>>;
  setCurrentVehicleQuestion: React.Dispatch<React.SetStateAction<string | undefined>>;
  currentTabIndex: number;
  setCurrentTabIndex: React.Dispatch<React.SetStateAction<number>>;
  isVehicleQuestionsYMMEOpen: boolean;
  setVehicleQuestionsYMMEOpen: React.Dispatch<React.SetStateAction<boolean>>;
  setTemporaryVehicle: React.Dispatch<React.SetStateAction<CurrentVehicle>>;
  isIntentionalBackClicked: boolean;
  setIsIntentionalBackClicked: React.Dispatch<React.SetStateAction<boolean>>;
  temporaryVehicle: CurrentVehicle;
  closeYmmeWidget?: (vehicleWasSelected?: boolean) => void;
  currentVehicleQuestion?: string;
  showSignInModal: boolean;
  setShowSignInModal: React.Dispatch<React.SetStateAction<boolean>>;
  signInUsername: string;
  setSignInUsername: React.Dispatch<React.SetStateAction<string>>;
};

export const YMMEInfoContext = createContext<YMMEInfoContexValue>({
  setCurrentTabIndex: () => {},
  currentTabIndex: 0,
  activeStep: 0,
  setActiveStep: () => {},
  setCurrentVehicleQuestion: () => {},
  isVehicleQuestionsYMMEOpen: false,
  setVehicleQuestionsYMMEOpen: () => {},
  setTemporaryVehicle: () => {},
  temporaryVehicle: {},
  isIntentionalBackClicked: false,
  setIsIntentionalBackClicked: () => {},
  currentVehicleQuestion: '',
  showSignInModal: false,
  setShowSignInModal: () => {},
  signInUsername: '',
  setSignInUsername: () => {},
});
